import React from "react";
import { useParams } from "react-router-dom";
import useCurrentPublication from "utilities/contexts/use-current-publication";
import useAnnex from "utilities/hooks/domain/publications/annexes/use-annex";
import useAnnexTables from "utilities/hooks/domain/publications/annexes/use-annex-tables";
import useAdminPreview from "utilities/hooks/use-admin-preview";
import { useErrorBoundary } from "utilities/hooks/use-error-boundary";
import useErrors from "utilities/hooks/use-errors";
import useLoading from "utilities/hooks/use-loading";
import TablesList from "./tables-list";

interface AnnexTablesContentProps {}
interface RouteParams {
    annexId: string;
    annexNfpaLabel: string;
}

const AnnexTablesContent: React.FunctionComponent<AnnexTablesContentProps> = (
    props: AnnexTablesContentProps
) => {
    const { publication } = useCurrentPublication();
    const { annexId, annexNfpaLabel } = useParams<RouteParams>();
    const { isAdminPreview } = useAdminPreview();

    const {
        errors: annexErrors,
        loaded: annexLoaded,
        loading: annexLoading,
        resultObject: annex,
    } = useAnnex(publication?.id, annexId, annexNfpaLabel);

    const {
        errors: tablesErrors,
        loaded: tablesLoaded,
        loading: tablesLoading,
        resultObject: tables,
    } = useAnnexTables(annex.id, isAdminPreview);

    const errors = useErrors(annexErrors, tablesErrors);
    useErrorBoundary(errors);

    const loaded = annexLoaded && tablesLoaded;
    const loading = useLoading(annexLoading, tablesLoading);

    const title = annex.getDisplayTitleWithNumber();

    return (
        <TablesList
            errors={errors}
            loaded={loaded}
            loading={loading}
            publicationType={publication?.type!}
            tables={tables}
            title={title}
        />
    );
};

export default AnnexTablesContent;
